module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isClose) ? _c('div', {
    staticClass: "fullPage",
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "how"
  }, [_c('p', {
    staticClass: "tit"
  }, [_vm._v("如何获取红包")]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("\n            1.在[查缺补漏]或[超越自我]类别中，每天完成一份在线练习，即可获得一个礼包。\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("\n            2.每人每天最多可获得1个礼包\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "sure",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("确定")])])]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a5eea0f6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a5eea0f6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layer/waysLayer.vue
// module id = 394
// module chunks = 6